package com.bikompanion.ui.models

/** Where the refresh cycle stands, so the screen can say when new numbers are due. */
sealed interface RefreshStatus {
    /** Nothing on screen is being polled — zoomed out past the stations, or stopped. */
    data object Idle : RefreshStatus

    data class Waiting(
        val secondsRemaining: Int,
    ) : RefreshStatus

    data object Refreshing : RefreshStatus
}
